<template>
  <div>
    <div class="position-relative form-group col-12 p-0">
      <label class="col-12 mb-0 p-0">Chat Id*</label>
      <input class="form-control mt-2" type="text" :value="meta.chat_id" @change.stop.prevent="store.commit('meta.chat_id', $event.currentTarget.value)" />
    </div>
    <div class="position-relative form-group col-12 p-0">
      <label>Bot*</label>
      <Select source="bot/search" field="telegram" placeholder="Bot" :value="meta.bot" @changeValue="store.commit('meta.bot', $event)" multiple></Select>
    </div>
    <div class="position-relative form-group col-12 p-0">
      <label>Trigger*</label>
      <Select :options="more.trigger" placeholder="Status" data-title="Status" class="has-tip" :value="meta.trigger" @changeValue="store.commit('meta.trigger', $event)"></Select>
    </div>
    <div class="position-relative form-group col-12 p-0">
      <label>Message*</label>
      <textarea class="form-control" placeholder="Message" :value="meta.message" @change.stop.prevent="store.commit('meta.message', $event.target.value)"></textarea>
      <small v-if="fields">
        <i>
          <span>Allow</span>
          <span v-for="(field, index) in fields" :key="index">&#123;&#123;&#37; {{ field }} &#37;&#125;&#125; </span>
        </i>
      </small>
    </div>
    <button @click.prevent="testTemplate" type="submit" class="btn btn-outline-success">Test</button>
  </div>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  computed: {
    storeId() {
      return this.config?.storeId
    },
    templateId() {
      return this.config?.templateId
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return this.data?.meta || {}
    },
    more() {
      return Object.assign(
        {
          trigger: []
        },
        this.data.more || {}
      )
    },
    fields() {
      if (this.meta.trigger) {
        for (const [, item] of Object.entries(this.more.trigger || [])) {
          if (item.id == this.meta.trigger) {
            return Object.values(item.fields)
          }
        }
      }
      return null
    }
  },
  methods: {
    testTemplate() {
      let data = Object.assign(
        {
          action: 'test',
          type: 'message'
        },
        this.data
      )
      this.$util.post(`template/extra/${this.templateId}`, data, this.$el)
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss"></style>
